module.exports={close:"Zavřít",error:"Chyba",info:"Informace",success:"Úspěch",warning:"Upozornění"};